// Generated by avro-typescript-cli
// Schemas:
//   HeroPostOpenPostExperience:6
//   HeroPostOpenFlyer:7
//   HeroPostFlyerViewFlyer:7
//   HeroPostFlyerEngagedVisitFlyer:7
//   HeroPostFlyerClickFlyerItem:7
//   HeroPostClosePost:8
//   BrowseAdAdaptedImpressionAd:2
//   BrowseAdAdaptedOpenAddToCartAd:2
//   BrowseAdAdaptedOpenAddToShoppingListAd:2
//   BrowseAdAdaptedViewableImpressionAd:2
  export enum ApplicationID { FlippApp = "FlippApp", ReebeeApp = "ReebeeApp", FlippWeb = "FlippWeb", Flyers = "Flyers", Hosted = "Hosted", GMA = "GMA", Editorials = "Editorials", Hero = "Hero", ShopperPlatform = "ShopperPlatform", FlippPlatformSdk = "FlippPlatformSdk", Other = "Other", FlippAvroDefault = "FlippAvroDefault" }

  /**
    Tracks the parameters that are common to all beacons
  */
  export interface Base {
    /** The application id */
    aid: ApplicationID;
    /** Random string that is used for cache busting purposes. */
    rnd: string;
    /** The Postal or ZIP Code stored in the application for the user */
    postalCode: null | { "string" : string};
  }

  /**
    Budget properties related to a particular item
  */
  export interface Budget {
    /** The budget id as defined by marketplace */
    budgetId: number;
    /** The Cost Model Type as defined by auction house */
    costModelType: null | { "string" : string};
  }

  /**
    Parameters specific to the publisher
  */
  export interface Publisher {
    /** The publisherId as displayed originally sourced from Fadmin */
    publisherId: number;
    /** Publisher's channel id (different from publisher id) */
    channelId: null | { "long" : number};
  }

  export enum Environment { Prod = "Prod", Dev = "Dev", Test = "Test" }

  /**
    Tracks the window position and size parameters for hero module post-expansion
  */
  export interface ClientParameters {
    /** Browser name. eg. Firefox, Opera */
    browser: string;
    /** Browser version */
    browserVersion: string;
    /** Operation System. eg. Windows, OSX, iOS, Android */
    system: string;
    /** The system model name. Can be device vendor. (e.g OnePlus, LG) */
    systemModel: string;
    /** Operation System Version. eg. 10.6 on OSX would be Mavricks */
    systemVersion: string;
  }

  export enum LocationSource { Unknown = "Unknown", GeoIP = "GeoIP", Default = "Default" }

  /**
    Tracks the parameters that are common to all Hero pre-experience beacons
  */
  export interface HeroCampaign {
    /** Module identifier from FAdmin system */
    moduleId: number;
    /** Unique id of hero campaign from Dist Campaign Admin */
    campaignId: number;
  }

  /**
    Tracks the parameters that are common to all Hero pre-experience beacons
  */
  export interface HeroBase {
    /** Tracks the environment */
    environment: Environment;
    /** User device (client) parameters, like browser version etc */
    clientParameters: ClientParameters;
    /** Tracks the source of defining user's postal code */
    LocationSource: LocationSource;
    /** Milliseconds since the Unix epoch, to allow for the accurate computation of dwell time */
    epochMilliseconds: number;
    /** Unique id representing a user browsing session. This is refreshed when user abandons the experience */
    sessionId: string;
    /** The long value that determines the order that the beacon was sent. A higher value indicates the beacon was sent after a lower valued one. */
    sequenceId: number;
    /** Version of loaded application that generated this message. */
    appVersion: string;
    heroCampaign: HeroCampaign;
  }

  /**
    Major Feature: Hero Post-Experience Minor Feature: None Action: Open Target Entity: Post-Experience This event fires post experiece code loads (at this point, user will see blank screen of loading spinner)
  */
  export interface HeroPostOpenPostExperience {
    base: Base;
    budget: Budget;
    publisher: Publisher;
    heroBase: HeroBase;
    schemaInfo: { schemaId: 7844 },
  }

  /**
    Properties related to a particular flyer
  */
  export interface Flyer {
    /** The flyerID as defined by Fadmin */
    flyerId: number;
    /** The flyerRunID as defined by Fadmin */
    flyerRunId: number;
    /** The flyerType as defined by Fadmin */
    flyerTypeId: number;
    /** The storeId is the Flipp internal store ID */
    storeId: null | { "long" : number};
    /** The premium status of the Flyer based on remaining budget at the time of beacon creation. */
    premium: boolean;
  }

  /**
    Parameters specific to the merchant
  */
  export interface Merchant {
    /** The merchantId as displayed originally sourced from Fadmin */
    merchantId: number;
  }

  export enum SourceAction { Direct = "Direct", CrossBrowse = "CrossBrowse" }

  /**
    Major Feature: Hero Post-Experience Minor Feature: None Action: Open Target Entity: Flyer This event fires once post-experience loads the actual hero flyer.
  */
  export interface HeroPostOpenFlyer {
    base: Base;
    budget: Budget;
    publisher: Publisher;
    flyer: Flyer;
    merchant: Merchant;
    /** What lead to this page, cross-browsing (opening another flyer from within post expansion) is tracker here */
    sourceAction: SourceAction;
    heroBase: HeroBase;
    schemaInfo: { schemaId: 7843 },
  }

  /**
    Tracks the window position and size parameters for hero module post-expansion
  */
  export interface ViewParameters {
    /** Left window boundary */
    left: number;
    /** Right window boundary */
    right: number;
    /** Top window boundary */
    top: number;
    /** Bottom window boundary */
    bottom: number;
    /** User screen resolution */
    resolution: number;
    /** User screen height */
    userScreenHeight: number;
    /** User screen width */
    userScreenWidth: number;
    /** Pixel density of a device. A device pixel ratio of 2 would be retina display. */
    devicePixelRatio: number;
  }

  /**
    Major Feature: Hero Post-Experience Minor Feature: None Action: View Target Entity: Flyer This event fires once hero flyer is visible in post-experience window for 500ms (0.5 seconds), also it's sent for every navigation event on the flyer.
  */
  export interface HeroPostFlyerViewFlyer {
    base: Base;
    budget: Budget;
    publisher: Publisher;
    flyer: Flyer;
    merchant: Merchant;
    heroBase: HeroBase;
    viewParameters: ViewParameters;
    schemaInfo: { schemaId: 7842 },
  }

  /**
    Major Feature: Hero Post-Experience Minor Feature: Flyer Action: EngagedVisit Target Entity: Flyer This event fires once user clicked on any item, scrolled, or flyer is visible for 6 seconds.
  */
  export interface HeroPostFlyerEngagedVisitFlyer {
    base: Base;
    budget: Budget;
    publisher: Publisher;
    flyer: Flyer;
    merchant: Merchant;
    heroBase: HeroBase;
    /** Has user already engaged? this flyer */
    repeat: boolean;
    schemaInfo: { schemaId: 7841 },
  }

  /**
    The Flyer Item properties
  */
  export interface FlyerItem {
    /** The ID of the Flyer Item as defined by its source of truth */
    id: number;
  }

  /**
    Major Feature: Hero Post-Experience Minor Feature: Flyer Action: Click Target Entity: FlyerItem This event fires once user clicked on any flyer item
  */
  export interface HeroPostFlyerClickFlyerItem {
    base: Base;
    budget: Budget;
    publisher: Publisher;
    flyer: Flyer;
    flyerItem: FlyerItem;
    merchant: Merchant;
    heroBase: HeroBase;
    schemaInfo: { schemaId: 7840 },
  }

  /**
    Major Feature: Hero Post-Experience Minor Feature: None Action: Close Target Entity: Post-Experience This event fires once user clicked on close action on post-experience window or closed tab/browser
  */
  export interface HeroPostClosePost {
    base: Base;
    budget: Budget;
    publisher: Publisher;
    flyer: Flyer;
    merchant: Merchant;
    heroBase: HeroBase;
    schemaInfo: { schemaId: 7997 },
  }

  /**
    Tracks the parameters that are common to all Flipp Web beacons
  */
  export interface FlippWebBase {
    /** The Application version of the flipp web */
    appVersion: string;
  }

  /**
    Extentsion of FlippWebBase protocol, it tracks the additional params that are common for Flipp Web beacons. We need to use this extension for not to break conversion of existent legacy beacons to avro beacons where FlippWebBase protocol is used
  */
  export interface FlippWebBaseExtended {
    /** User device (client) parameters, like browser version etc */
    clientParameters: ClientParameters;
    /** Tracks the environment */
    environment: Environment;
    /** Tracks the source of defining user's postal code */
    locationSource: LocationSource;
    /** Milliseconds since the Unix epoch, to allow for the accurate computation of dwell time */
    epochMilliseconds: number;
    /** Unique id representing a user browsing session. This is refreshed when user abandons the experience */
    sessionId: string;
    /** The long value that determines the order that the beacon was sent. A higher value indicates the beacon was sent after a lower valued one. */
    sequenceId: number;
  }

  /**
    The user account associated with the Flipp ecosystem
  */
  export interface UserAccount {
    /** The account ID string associated with the user */
    accountId: string;
  }

  /**
    The Browse Page properties. These properties are related to the context in which Browse events take place.
  */
  export interface BrowseContext {
    /** The title name of the browse page. Freeform string because it may change depending on server content */
    pageName: string;
  }

  /**
    Represents universal contextual information about an AdAdapted ad.
  */
  export interface AdAdaptedAdContext {
    /** Flipp-powered ID set from our side to uniquely identify AdAdapted ad slots. The IDS are different for different ad slots but the same for all sessions, i.e. currently there are two ad slots and they have ids: - flipp_web_flyer_list_ad_adapted_1 - flipp_web_flyer_list_ad_adapted_2 */
    id: string;
    /** zoneId is similar to GAM's ad_unit, serves as a key of sorts to grab an ad from a specific pool for ads. */
    zoneId: string;
  }

  /**
    Fired when an AdAdapted ad has at least one pixel visible on the browse screen
  */
  export interface BrowseAdAdaptedImpressionAd {
    base: Base;
    flippWebBase: FlippWebBase;
    flippWebBaseExtended: FlippWebBaseExtended;
    userAccount: null | { "com.flipp.beacon.common.entity.UserAccount" : UserAccount};
    browseContext: BrowseContext;
    adAdaptedAdContext: AdAdaptedAdContext;
    schemaInfo: { schemaId: 8209 },
  }

  /**
    This event is fired when the user clicks on an AdAdapted ad in Browse that opens partner website. This is different from the Adding To Shopping list beacon as the user doesn't actually add any items to their shopping list. Instead they are taken to a partner website in a webview
  */
  export interface BrowseAdAdaptedOpenAddToCartAd {
    base: Base;
    flippWebBase: FlippWebBase;
    flippWebBaseExtended: FlippWebBaseExtended;
    userAccount: null | { "com.flipp.beacon.common.entity.UserAccount" : UserAccount};
    browseContext: BrowseContext;
    adAdaptedAdContext: AdAdaptedAdContext;
    schemaInfo: { schemaId: 8210 },
  }

  /**
    Adadapted item and its associated metadata. Values here are owned and defined by AdAdapted, they have no relationship to Flipp's data. This informaton is only available post-click of an ad, thus it cannot be part of AdAdapted ad impressions. The list of available fields in AdAdapted documentation -> https://docs.adadapted.com/#/docs/javascript-callbacks?id=onadditemstriggered.
  */
  export interface AdAdaptedItem {
    /**  The barcode of the product. */
    productBarcode: string;
    /**  The brand of the product. */
    productBrand: string;
    /**  The category of the product. */
    productCategory: string;
    /**  The discount given for the product. */
    productDiscount: string;
    /**  The image used for display of the product. */
    productImage: string;
    /**  The SKU of the product. */
    productSku: string;
    /**  The name/title of the product. */
    productTitle: string;
    /**  Can be empty, internal tracking for AdAdapted, can be ignored. */
    trackingId: string;
  }

  /**
    Fired when an AdAdapted item added to shopping list
  */
  export interface BrowseAdAdaptedOpenAddToShoppingListAd {
    base: Base;
    flippWebBase: FlippWebBase;
    flippWebBaseExtended: FlippWebBaseExtended;
    userAccount: null | { "com.flipp.beacon.common.entity.UserAccount" : UserAccount};
    browseContext: BrowseContext;
    adAdaptedAdContext: AdAdaptedAdContext;
    listAdAdaptedItems: AdAdaptedItem[];
    schemaInfo: { schemaId: 8211 },
  }

  /**
    Fired when an AdAdapted ad was 50% visible for at least 1 second on the browse screen.
  */
  export interface BrowseAdAdaptedViewableImpressionAd {
    base: Base;
    flippWebBase: FlippWebBase;
    flippWebBaseExtended: FlippWebBaseExtended;
    userAccount: null | { "com.flipp.beacon.common.entity.UserAccount" : UserAccount};
    browseContext: BrowseContext;
    adAdaptedAdContext: AdAdaptedAdContext;
    schemaInfo: { schemaId: 8212 },
  }

export const HeroPostOpenPostExperienceSchemaId = 7844
export const HeroPostOpenFlyerSchemaId = 7843
export const HeroPostFlyerViewFlyerSchemaId = 7842
export const HeroPostFlyerEngagedVisitFlyerSchemaId = 7841
export const HeroPostFlyerClickFlyerItemSchemaId = 7840
export const HeroPostClosePostSchemaId = 7997
export const BrowseAdAdaptedImpressionAdSchemaId = 8209
export const BrowseAdAdaptedOpenAddToCartAdSchemaId = 8210
export const BrowseAdAdaptedOpenAddToShoppingListAdSchemaId = 8211
export const BrowseAdAdaptedViewableImpressionAdSchemaId = 8212
export type AnySchemaId = 7844|7843|7842|7841|7840|7997|8209|8210|8211|8212;
export type AnySchema = HeroPostOpenPostExperience|HeroPostOpenFlyer|HeroPostFlyerViewFlyer|HeroPostFlyerEngagedVisitFlyer|HeroPostFlyerClickFlyerItem|HeroPostClosePost|BrowseAdAdaptedImpressionAd|BrowseAdAdaptedOpenAddToCartAd|BrowseAdAdaptedOpenAddToShoppingListAd|BrowseAdAdaptedViewableImpressionAd;
export interface SchemaIdMap {
    7844: HeroPostOpenPostExperience,
    7843: HeroPostOpenFlyer,
    7842: HeroPostFlyerViewFlyer,
    7841: HeroPostFlyerEngagedVisitFlyer,
    7840: HeroPostFlyerClickFlyerItem,
    7997: HeroPostClosePost,
    8209: BrowseAdAdaptedImpressionAd,
    8210: BrowseAdAdaptedOpenAddToCartAd,
    8211: BrowseAdAdaptedOpenAddToShoppingListAd,
    8212: BrowseAdAdaptedViewableImpressionAd,
};
export type SchemaFor<T extends keyof SchemaIdMap> = SchemaIdMap[T];

